import _ from 'underscore'

import Api from 'services/api'
import BaseModel from 'models/BaseModel'
import { color } from 'styles/colors'

const defaultDeviceMetric = {
  id: '',
  name: '',
  description: '',
  callToAction: [],
  draft: true,
  unit: '',
  validatedSaveType: ''
}

class DeviceMetricModel extends BaseModel {
  constructor (options = defaultDeviceMetric) {
    super(options || defaultDeviceMetric)
    Object.seal(this)
  }

  save (deviceMetrics, trends, validatedSaveType, updatedDeviceMetricAttributes, onSaveSuccessCallback, onSaveFailCallback, onValidationErrorCallback) {
    const errors = { ...this._validate(deviceMetrics, trends, updatedDeviceMetricAttributes, validatedSaveType) }

    if (_.isEmpty(errors)) {
      const apiMethodName = updatedDeviceMetricAttributes.id && validatedSaveType === 'update' ? 'update' : 'create'

      return Api.DeviceMetrics[apiMethodName]({ ...defaultDeviceMetric, ...updatedDeviceMetricAttributes })
        .then((response) => {
          onSaveSuccessCallback(response)
        })
        .catch(() => {
          onSaveFailCallback()
        })
    } else {
      onValidationErrorCallback(errors)
    }
  }

  delete (onDeleteSuccessCallback, onDeleteFailCallback, deviceMetric) {
    return Api.DeviceMetrics.delete(deviceMetric.id)
      .then(() => {
        onDeleteSuccessCallback()
      })
      .catch(async (error) => {
        if (error.status === 400) {
          const errorResponse = await error.json()
          onDeleteFailCallback(errorResponse?.base[0].name)
        } else {
          onDeleteFailCallback('Delete Failed')
        }
      })
  }

  _validate (deviceMetrics, trends, attributes, validatedSaveType) {
    const errors = {}
    const existingMetric = attributes.id && deviceMetrics?.filter((metric) => metric.id === attributes.id)
    const publishedTrend = () => {
      return _.find(trends, (trend) => !trend.draft && _.any(trend.metricList, (metric) => metric.id === attributes.id))
    }

    if (!_.isEmpty(existingMetric) && validatedSaveType === 'create') {
      errors.id = 'Metric ID is already in use by another metric'
    }

    if (!attributes.id) {
      errors.id = 'ID is required'
    }

    if (attributes.id && !/^[a-z_]+$/.test(attributes.id) && validatedSaveType === 'create') {
      errors.id = 'ID should be in lowercase with underscore are valid( eg: sample_metric_id )'
    }

    if (attributes.draft && publishedTrend() && validatedSaveType === 'update') {
      errors.draft = `Draft status cannot be changed while metric is in a published trend (${publishedTrend()?.name})`
    }

    if ((attributes.color || '').toLowerCase() === color('paneBackground').toLowerCase()) {
      errors.color = 'white color cannot be selected'
    }

    if (!attributes.name) {
      errors.name = 'Name is required'
    }

    if (!attributes.description) {
      errors.description = 'Description is required'
    }

    return errors
  }
}

export default DeviceMetricModel
